(function () {

    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const HEADER = rem * 4; // 4rem = top-16

    const sections = document.querySelectorAll('.sticky-column');
    if (!sections.length) return;

    sections.forEach((section, i) => section.style.zIndex = i + 1);

    // position:sticky påverkar offsetTop — använd istället förälderns BCR
    // (föräldern är inte sticky) plus kumulativ offsetHeight för föregående syskon.
    const container = sections[0].parentElement;
    const isDesktop = window.matchMedia('(min-width: 1024px)');
    let items = [];

    const SECTION_HEIGHT = 660;

    function measure() {
        const containerDocTop = container.getBoundingClientRect().top + window.scrollY;
        items = Array.from(sections).map((section, i) => {
            const rightCol = section.querySelector(':scope > .wp-block-column:last-child');
            if (!rightCol) return null;
            const stickyAt = containerDocTop + (i * SECTION_HEIGHT) - HEADER;
            return { section, rightCol, stickyAt };
        }).filter(Boolean);
    }

    function update() {
        if (!isDesktop.matches) {
            items.forEach(({ rightCol }) => {
                rightCol.style.transform = '';
                rightCol.style.opacity = '';
            });
            return;
        }

        items.forEach(({ rightCol, stickyAt }, i) => {
            const isLast = i === items.length - 1;
            if (isLast) {
                rightCol.style.transform = '';
                rightCol.style.opacity = '';
                return;
            }
            const maxPast = items[i + 1].stickyAt - stickyAt;
            const scrolledPast = Math.min(Math.max(0, window.scrollY - stickyAt), maxPast);
            rightCol.style.transform = scrolledPast ? `translateY(-${scrolledPast}px)` : '';
            rightCol.style.opacity = maxPast > 0 && scrolledPast >= maxPast ? '0' : '1';
        });
    }

    // Starta scroll-hanteringen omedelbart — vänta inte på load.
    // Utan detta saknas transforms helt om besökaren scrollar innan bilderna laddat.
    measure();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', () => { measure(); update(); }, { passive: true });
    update();

    // Mät om vid load ifall containern har förflyttats av bilder ovanför.
    window.addEventListener('load', () => { measure(); update(); });

})();

//# sourceMappingURL=sticky-column.js.map
